import React, { Component } from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { I18n } from 'react-i18next';

class SelectInput extends Component {
  state = {
    selectedOption: this.props.selected || this.props.value || '',
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.selected !== this.props.selected || nextProps.value !== this.props.value) {
      this.setState({ selectedOption: nextProps.selected || nextProps.value || '' });
    }
  }

  onOpen = () => {
    if (this.props.onListOpen) {
      this.props.onListOpen(this.props.value);
    }
  };

  onClose = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  onChange = (selectedOption) => {
    this.setState({ selectedOption });
    if (this.props.handleChange) {
      this.props.handleChange(selectedOption, this.props.title);
    }
  };

  valueRenderer = (option, t, labelAsPlaceholder) => {
    if (!option || (!option.label && option.value !== 0)) {
      return null;
    }

    const label = this.props.title
      ? (t('api_filters', { returnObjects: true })[this.props.title] || this.props.title)
      : '';

    if (labelAsPlaceholder) {
      return <span className="select-value-text">{option.label}</span>;
    }

    return (
      <>
        <span className="select-label">
          {label}
        </span>
        <span className="select-value-text">{option.label}</span>
      </>
    );
  };

  placeholderRenderer = (t, showPlaceholderText, labelAsPlaceholder) => {
    const label = this.props.title
      ? (t('api_filters', { returnObjects: true })[this.props.title] || this.props.title)
      : '';

    const placeholderText = showPlaceholderText
      ? t('generic_labels.please_select')
      : '';

    if (labelAsPlaceholder) {
      return <span className="select-placeholder-text">{label}</span>;
    }

    return (
      <>
        <span className="select-label">
          {label}
        </span>
        <span className="select-placeholder-text">{placeholderText}</span>
      </>
    );
  };

  arrowRenderer = () => (
    <svg width="20" height="11" viewBox="0 0 20 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.99647 11C9.73213 11.0005 9.47031 10.9476 9.22607 10.8445C8.98183 10.7414 8.75998 10.5901 8.5733 10.3992L0 1.44019L1.44435 0L10.0086 8.94978L18.5557 0L20 1.44019L11.4368 10.39C11.248 10.5835 11.0236 10.737 10.7764 10.8417C10.5292 10.9464 10.2641 11.0002 9.99647 11Z" fill="black" />
    </svg>
  );

  render() {
    const { options, selectOptions } = this.props;
    const currentOptions = selectOptions || options;

    let selectedOption =
      (currentOptions.length === 1 && currentOptions[0] && currentOptions[0].value !== '') ? currentOptions[0] : this.state.selectedOption;

    let normalizedValue = selectedOption;
    const valueToMatch = (normalizedValue && typeof normalizedValue === 'object') ? normalizedValue.value : normalizedValue;

    if (valueToMatch === '' || Array.isArray(valueToMatch) || valueToMatch === null || valueToMatch === undefined) {
      normalizedValue = null;
    } else {
      normalizedValue = currentOptions.find(o => o.value == valueToMatch) || null;
    }

    return (
      <I18n ns="translations">
        {(t) => {
          const showPlaceholderText = this.props.showPlaceholderText !== undefined ? this.props.showPlaceholderText : true;
          const labelAsPlaceholder = !!this.props.labelAsPlaceholder;

          return (
            <div className="input">
              <Select
                disabled={this.props.disabled}
                onClose={this.onClose}
                onOpen={this.onOpen}
                placeholder={this.placeholderRenderer(t, showPlaceholderText, labelAsPlaceholder)}
                clearable={false}
                name={'form-field-' + this.props.title}
                onChange={this.onChange}
                value={normalizedValue}
                options={currentOptions}
                searchable={false}
                valueRenderer={(option) => this.valueRenderer(option, t, labelAsPlaceholder)}
                arrowRenderer={this.arrowRenderer}
              />
            </div>
          );
        }}
      </I18n>
    );
  }
}

export default SelectInput;
